import { ForwardedRef, MutableRefObject, useEffect, useRef } from "react";

export default function useCombinedRefs<T>(...refs: Array<ForwardedRef<T> | null>): MutableRefObject<T | null> {
  const targetRef = useRef(null);

  useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) {
        return;
      }

      if (typeof ref === "function") {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
}
